export default {"src":"/_next/static/media/azure-virtual-machines.2570a391.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};